/**
 * Arcℏimedian DSaaS — Design Tokens
 * Dark theme with teal/blue/purple accents.
 * Shared across all pages and components.
 */

export const theme = {
  // Backgrounds
  bg: '#0A0E1A',
  bgCard: '#111827',
  bgCardHover: '#1a2236',
  surface: '#1E293B',
  surfaceLight: '#334155',
  surfaceHover: '#283548',

  // Borders
  border: '#1E293B',
  borderLight: '#334155',
  borderFocus: '#06D6A0',

  // Text
  text: '#F8FAFC',
  textMuted: '#94A3B8',
  textDim: '#64748B',

  // Accents
  accent: '#06D6A0',
  accentDark: '#049a74',
  accentGlow: 'rgba(6,214,160,0.15)',
  accentBlue: '#3B82F6',
  accentPurple: '#8B5CF6',
  accentOrange: '#F59E0B',

  // Status
  danger: '#EF4444',
  dangerGlow: 'rgba(239,68,68,0.1)',
  success: '#06D6A0',
  warning: '#F59E0B',

  // Gradients
  gradient: 'linear-gradient(135deg, #06D6A0 0%, #3B82F6 50%, #8B5CF6 100%)',
  gradientSubtle: 'linear-gradient(135deg, rgba(6,214,160,0.08) 0%, rgba(59,130,246,0.08) 100%)',

  // Typography
  fontSans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  fontDisplay: "'Playfair Display', Georgia, serif",
  fontMono: "'JetBrains Mono', 'Fira Code', monospace",

  // Sizing
  sidebarWidth: 260,
  headerHeight: 64,
  radius: 12,
  radiusSm: 8,
} as const;

export const FONTS_URL =
  'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Playfair+Display:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap';

export type Theme = typeof theme;
